<template>
    <div class="message-popup">
        <div class="notification" v-for="message in messages" :key="message.id" :class="message.type">
            {{ message.message }}
            <div class="progress-bar-container">
                <div class="progress-bar" :style="{ animationDuration: message.duration + 'ms' }"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import * as namespaceStore from "../../vuexStore/namespaceStore.js"

export default {
    name: "MessagePopup",
    computed: {
        ...mapGetters(namespaceStore.MESSAGE, [
            "messages"
        ]),
    },
    methods: {
        ...mapActions(namespaceStore.MESSAGE, [
            "addMessage"
        ]),
    }
}
</script>

<style scoped>
.message-popup {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 15000;
    display: flex;
    flex-direction: column;
    gap: 15px;
    left: 20px;
    align-items: center;
    pointer-events: none;
}

.notification {
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    max-width: 300px;
    word-wrap: break-word;
    position: relative;
    overflow: hidden;
}

.progress-bar-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: #5a5a5a8c;
    overflow: hidden;
    border-radius: 0 0 8px 8px;
}

.progress-bar { 
    height: 100%;
    width: 100%;
    transform-origin: left;
    background-color: #b9b9b9d3;
    animation: animationProgressBar 0s linear infinite;
}

@keyframes animationProgressBar {
    from {
        transform: scaleX(0);
    }
    to {
        transform: scaleX(1);
    }
}

.success {
    background-color: #10b981;
}
.error {
    background-color: #ef4444;
}
</style>